import { Container, Flex, Box, Text, Link, Image, useMediaQuery } from "@chakra-ui/react"
import SocialIcons from "components/header/SocialIcons"
import EmailSignup from "components/forms/EmailSignup"
import SocialMediaSection from "components/ui/SocialMediaSection"

export default function FooterTct2026({ socialFooterText }) {
    const [mobile] = useMediaQuery("(max-width: 1023px)")

    return (
        <Container
            as="footer"
            bgGradient="to-r"
            gradientFrom="color1"
            gradientTo="color2"
            maxW="100%"
            pb="40px"
            color="#fff"
            fontSize="11px"
            zIndex={10}
        >
            <Box pb={2} mt={mobile ? 2 : 1}>
                <SocialMediaSection
                    bgColor="transparent"
                    text={socialFooterText || "Join the Conversation #TCT2026"}
                    className="socialFooter"
                    textColor="#fff"
                    iconColor="#fff"
                    textAlign="center"
                />
            </Box>

            <Flex
                maxW={{ xl: 1200 }}
                w="100%"
                mx="auto"
                px={{ base: "20px", lg: 0 }}
                justify="space-between"
                direction={{ base: "column", lg: "row" }}
                align="flex-start"
                gap={{ base: 0, lg: 8 }}
            >
                {mobile && (
                    <Box
                        display={{ base: "block", lg: "none" }}
                        width="100%"
                        height={"1px"}
                        bg="white"
                        alignSelf="stretch"
                        mb={"20px"}
                    />
                )}
                <Box width={mobile ? "100%" : "auto"}>
                    <Link
                        href={"http://crf.org/"}
                        target="_blank"
                        textAlign={mobile ? "center" : "left"}
                        margin={mobile ? "0 auto" : "auto"}
                        width={mobile ? "100%" : "auto"}
                    >
                        <Image
                            src="https://assets.crfconnect.com/shared/CRF-logos/crf_logo_2026.svg"
                            width={"194px"}
                            alt="CRF Logo"
                            margin={mobile ? "0 auto" : "auto"}
                        />
                    </Link>

                    <Text mt={2} ml={mobile ? 0 : 14} textAlign={mobile ? "center" : "left"}>
                        1700 Broadway, 9th Floor
                        <br />
                        New York, NY 10019
                        <br />
                        646.434.4500
                        <br />
                        <Link textDecoration="underline" href="mailto:info@crf.org">
                            info@crf.org
                        </Link>
                    </Text>
                </Box>

                <Box display={{ base: "none", lg: "block" }} width="1px" bg="white" alignSelf="stretch" />
                <Box
                    display={{ base: "block", lg: "none" }}
                    width="100%"
                    height={"1px"}
                    bg="white"
                    alignSelf="stretch"
                    mt={"20px"}
                />

                <Box
                    mt={{ base: "20px", lg: 0 }}
                    css={
                        mobile && {
                            "& *": {
                                textAlign: "center",
                            },
                            "& input": {
                                textAlign: "left",
                            },
                        }
                    }
                    marginLeft={mobile ? "auto" : "none"}
                    marginRight={mobile ? "auto" : "none"}
                >
                    <EmailSignup headerColor="#fff" />
                </Box>

                <Box display={{ base: "none", lg: "block" }} width="1px" bg="white" alignSelf="stretch" />
                {mobile && (
                    <Box
                        display={{ base: "block", lg: "none" }}
                        width="100%"
                        height={"1px"}
                        bg="white"
                        alignSelf="stretch"
                        mt={"20px"}
                    />
                )}
                <Box
                    mt={{ base: "20px", lg: 0 }}
                    css={
                        mobile && {
                            "& *": {
                                textAlign: "center",
                            },
                            "& input": {
                                textAlign: "left",
                            },
                        }
                    }
                    marginLeft={mobile ? "auto" : "none"}
                    marginRight={mobile ? "auto" : "none"}
                >
                    <Text mt={0}>
                        © 2026, Cardiovascular Research Foundation<sup>®</sup>
                        <br />
                        All rights reserved.
                    </Text>
                    <p>
                        <Link textDecoration="underline" target="_blank" href="https://www.crf.org/privacy-policy">
                            Privacy Policy
                        </Link>
                        <br />
                        <Link
                            textDecoration="underline"
                            target="_blank"
                            href="https://www.crf.org/terms-and-conditions-of-use"
                        >
                            Terms and Conditions of Use
                        </Link>
                        <br />
                    </p>
                </Box>
            </Flex>
        </Container>
    )
}
